/* ****************************************************************************
Name:			  Cerfificate upload
**
** Desc:         This code is to manager supplier certificates
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------
**  11/02/2020  Vasu Pabbaraju.           Added logic to use Randomized data for MSSD I-Chart Graph = JIRA -- q360-395
**  02/26/2021  Vasu Pabbaraju.           Added logic not show graphs when cpk and ppk are 0 = JIRA -- Q360-437
**  02/26/2021  Vasu Pabbaraju.           Added logic not get fixed bonus tol values - JIRA -- Q360-463

******************************************************************************/ 



import React, {useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import ReactGA from 'react-ga';
import config from '../../config/okta.config';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import histogram from "highcharts/modules/histogram-bellcurve"; //module
import bellcurve from "highcharts/modules/histogram-bellcurve"; //module
import DataTable from 'react-data-table-component';
import { withAuth } from '@okta/okta-react';
import * as FileSaver from 'file-saver';

import {
    Card, Button, Modal, ModalBody
} from 'reactstrap';

const GET_PPQP_JSON = gql`
    query getPPQPJSON($FileGUID: String) {
      SupplierFilePPQPJSON(filters:{
        FileGUID:$FileGUID
          }) {
            edges {
              node {
                FileGUID
                PPQPJson
                LoadTS
              }
            }
          }
        }

`;


const Capability = (fileGuid) => {
  const [validatonData, setValidationData] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [showCapabilityError, setShowCapabilityError] = useState(null);
  const [CapabilitySummary, setCapabilitySummary] = useState(null);
  const [showLoader, setShowLoader] = useState(null);
  // const 
  histogram(Highcharts); //init module
  bellcurve(Highcharts); //init module

  const [getPPQPJSON] = useLazyQuery(GET_PPQP_JSON, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      ////console.log(data.SupplierFilePPQPJSON.edges);
      setCapabilitySummary([]);
      if (data.SupplierFilePPQPJSON.edges.length>0) {
        setCapabilitySummary(JSON.parse(data.SupplierFilePPQPJSON.edges[0].node.PPQPJson));
        ////console.log(JSON.parse(data.SupplierFilePPQPJSON.edges[0].node.PPQPJson));
        // setShowCapabilityError(true);
        setShowLoading(false);
      } else {
        setShowCapabilityError(true);
        setCapabilitySummary([]);
        
      }
    }
  });


  const columns = [
    {
      name: 'Capabiltiy Method',
      selector: 'CPKType',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      }
    },
    {
      name: 'Label',
      selector: 'FEATURE',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      }
    },
    {
      name: 'StDev Overall',
      cell: (row) => <span>{Number(row.stdev_overall).toFixed(5)} </span>,
      selector: 'stdev_overall',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      }
    },
    {
      name: 'StDev Within',
      cell: (row) => <span>{Number(row.stdev_within).toFixed(5)} </span>,
      selector: 'stdev_within',
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      }
    },
    {
      name: 'P-Value(AD)',
    cell: row => <div>{ Number(row.PValue).toFixed(3) } {(row.PValue > 0.05)?<i class="fas fa-check-circle"></i>:null}</div>,
    },
    {
      name: 'P-Value(Shapiro-Wilk)',
    cell: row => <div>{ Number(row.SH_PValue).toFixed(3) } {(row.PValue < 0.05 && row.SH_PValue > 0.05)?<i class="fas fa-check-circle"></i>:null}</div>,
    },
    {
      name: 'CPK',
      selector: 'CPK',
      cell: (row) => <span>{Number(row.CPK).toFixed(2)} </span>,
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    },
    {
      name: 'PPK',
      selector: 'PPK',
      cell: (row) => <span>{Number(row.PPK).toFixed(2)} </span>,

      sortable: true,
      style: {
        color: '#202124',
        fontSize: '14px',
        fontWeight: 500,
      },
    }];

  let options = {
    title: {
      text: 'I Chart'
  },
  credits: {
    enabled: false
},
    yAxis: {
   
      plotLines: [{
        value: 0.077,
        color: 'red',
        dashStyle: 'shortdash',
        width: 2,
        label: {
            text: 'LCL'
        }
    }, {
        value: 0.084,
        color: 'red',
        dashStyle: 'shortdash',
        width: 2,
        label: {
            text: 'UCL'
        }
    },{
      value: 0.077,
      color: 'green',
      dashStyle: 'shortdash',
      width: 2,
      label: {
          text: 'Mean'
      }
  },]
    },
    series: [{
      name:'Average Values',
      data: []
  }]
};
  
let options1 = {
  title: {
    text: 'Moving Range Chart'
},
credits: {
  enabled: false
},
yAxis: {
  plotLines: [{
    value: 0.077,
    color: 'red',
    dashStyle: 'shortdash',
    width: 2,
    label: {
        text: 'LCL'
    }
}, {
    value: 0.084,
    color: 'red',
    dashStyle: 'shortdash',
    width: 2,
    label: {
        text: 'UCL'
    }
}, {
  value: 0.084,
  color: 'green',
  dashStyle: 'shortdash',
  width: 2,
  label: {
      text: 'Mean'
  }
}]
},
  series: [{
    name:'Range',
    data: []
}]
};


useEffect(() => {

  if (!CapabilitySummary && !showLoading ) {
    setShowLoading(true);
    getPPQPJSON({
      variables: {
        FileGUID: fileGuid.fileGuid
      }
    });
  } else {
      // showDashboardData();// getFileValidationDetails({ variables: { FileGUID: reportFileGUID } });
  // setShowFinalReport(true);

  
  if (CapabilitySummary) {
    let tvalidation_data = [];
    if (!validatonData && CapabilitySummary.features) {
      CapabilitySummary.features.map((el) => {
        let tvalidation_object = {};
        // let metCapability = "";
        // let metCapability_sh = ""
        // if ( Number(el['PValue']).toFixed(5) > 0.05) {
        //   ////console.log(Number(el['SH_PValue']).toFixed(5));
        //       metCapability = "<i class='fas fa-check-circle'></i>";
        // } else {
        //   if (Number(el['SH_PValue']).toFixed(5) > 0.05) {
        //        metCapability_sh = "<i class='fas fa-check-circle'></i>";
        //   }
        // }
        tvalidation_object['FEATURE'] = el['feature'];
        tvalidation_object['CPK'] = Number(el['CPK']).toFixed(5);
        tvalidation_object['PPK'] = Number(el['PPK']).toFixed(5);
        tvalidation_object['PValue'] = Number(el['PValue']).toFixed(5) ;
        tvalidation_object['SH_PValue'] = Number(el['SH_PValue']).toFixed(5) ;
        tvalidation_object['stdev_overall'] = Number(el['stdev_overall']).toFixed(5);
        tvalidation_object['stdev_within'] = Number(el['stdev_within']).toFixed(5);
        tvalidation_object['CPKType'] = (el['CPKType']=='subgroup1')?'Moving Range':el['CPKType'];
        tvalidation_data.push(tvalidation_object);

      });
      setValidationData(tvalidation_data);
      ////console.log(showLoading)
      setShowLoading(false);
      document.getElementById('loadingdivCapability').style.display = 'none';
    }
  }

  }

});

function isJson(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

function exportPDFData() {
     
  
  setShowLoader(true);
  const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
  const userDetails = JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims;
 


  let url = window.location.origin + '/download_ppqp_chart';
  
  if (window.location.hostname == 'localhost') {
    url = 'http://' + window.location.hostname + ':5000/download_ppqp_chart';
  }

  fetch(url, {
    method: 'POST',
    body: JSON.stringify({htmlcontent:document.getElementById('GraphsData').innerHTML}),
    headers: {
      'Content-Type': 'application/json',
      'responseType': 'application/octet-stream',
      'authorization': token || null,
      'UserName': userDetails.name,
      'UserEmail': userDetails.email,
      'FileGuid': fileGuid.fileGuid,
      'authVendorID': localStorage.getItem('loggedInVendor')

    }
  }).then(function (response) {
    if (response.ok) {
      return response;
    }
    throw new Error('Network response was not ok.');
  }).then(res => res.blob())
    .then(blob => {
      // if (data['status']) {
      //   setShowDownloadPdf(true);
        
      // }
      FileSaver.saveAs(blob, 'PPQP-' + fileGuid.fileGuid  + '.pdf');
      setShowLoader(false);
    }).catch(err => {
      console.log(err);
      setShowLoader(false);
      alert('Oooops!, problem downloading pdf');

    }
    );

}

const conditionalRowStyles = [
  {
    when: row =>  row.selected,
    style: {
      backgroundColor: '#20c997',
      color: 'black',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  }
];

const generate_pp_chart = (featureData,feature) => {

  let  url = window.location.origin  + '/get_pp_chart';
  // const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
  if (window.location.hostname == 'localhost') {
      url = 'http://'+ window.location.hostname + ':5000/get_pp_chart';
  }
const formData = new FormData();
 const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;


        fetch(url, {
          method: 'POST',
          body: JSON.stringify({filter_data:featureData}),
          headers: {
              'Content-Type': 'application/json',  
              'authorization': token || null ,
              'authVendorID': localStorage.getItem('loggedInVendor')
          }
      }).then(res => res.json()).then(res => {
          // setHistplot(res['histogram']);
          // setqqplot(res['qqplot']);
          if (document.getElementById('histogram'+feature)){
            document.getElementById('histogram'+feature).innerHTML = res['histogram'];
          }
          if (document.getElementById('qqplot'+feature)) {
          document.getElementById('qqplot'+feature).innerHTML = res['qqplot'];
          }
      });
}

const getCapabilityGraph = (row,chartNumber) => {
  ////console.log(row);
  let t_options = options;
  if (chartNumber == 1) {
    if (row['CPKType'] == 'Pooled') {
      ////console.log(t_options);
      t_options.title.text = 'XBar Chart';
    }
    let filterData = CapabilitySummary.features.filter(feature => feature.feature == row['FEATURE'])[0];
    // console.log(filterData);
    generate_pp_chart(filterData,row['FEATURE']);

    t_options['yAxis'].min = Math.min(parseFloat(filterData.min_val).toFixed(5),parseFloat(filterData.LCL_ICHART).toFixed(5));
    t_options['yAxis'].max = Math.max(parseFloat(filterData.max_val).toFixed(5),parseFloat(filterData.UCL_ICHART).toFixed(5));
    t_options['yAxis']['plotLines'][0]['value'] = parseFloat(filterData.LCL_ICHART).toFixed(5);
    t_options['yAxis']['plotLines'][1]['value'] = parseFloat(filterData.UCL_ICHART).toFixed(5);
    t_options['yAxis']['plotLines'][2]['value'] = parseFloat(filterData.XBar).toFixed(5);

    t_options['yAxis']['plotLines'][0]['label']['text'] = 'LCL(' + parseFloat(filterData.LCL_ICHART).toFixed(5) + ')';
    t_options['yAxis']['plotLines'][1]['label']['text'] = 'UCL(' +  parseFloat(filterData.UCL_ICHART).toFixed(5)+ ')';
    t_options['yAxis']['plotLines'][2]['label']['text'] = 'Mean(' +  parseFloat(filterData.XBar).toFixed(5)+ ')';

    

    let AvaerageValues = JSON.parse(filterData.subgroup_averages).data;

    let tChart1Values = [];
    if (filterData.CPKType != 'MSSD') {
    AvaerageValues.map((el) => {
      if (el.Val < parseFloat(filterData.LCL_ICHART).toFixed(5) || el.Val > parseFloat(filterData.UCL_ICHART).toFixed(5)) {
        tChart1Values.push({marker:{fillColor:'red'},y:parseFloat(el.Val)});
      } else {
       
        tChart1Values.push({y:parseFloat(el.Val)});
      }
      
    });
  } else {

    filterData.randomized_data.map((el) => {
      if (el < parseFloat(filterData.LCL_ICHART).toFixed(5) || el > parseFloat(filterData.UCL_ICHART).toFixed(5)) {
        tChart1Values.push({marker:{fillColor:'red'},y:parseFloat(el)});
      } else {
        tChart1Values.push({y:parseFloat(el)});
      }
      
    });
  }


    ////console.log(tChart1Values);
    t_options.series[0].data= tChart1Values;
    return(t_options);
   
  } else if (chartNumber == 2) {
    let filterData = CapabilitySummary.features.filter(feature => feature.feature == row['FEATURE'])[0];
    let t_options1 = options1;
    if (row['CPKType'] == 'Pooled') {
      t_options1['title'].text = 'R Chart';
    }
    let max = 0;
    t_options1['yAxis'].min = 0;
    t_options1['yAxis'].max = parseFloat(filterData.UCL_MRCHART).toFixed(5);
    ////console.log(parseFloat(filterData.UCL_MRCHART))
    t_options1['yAxis']['plotLines'][0]['value'] = parseFloat(filterData.LCL_MRCHART).toFixed(5);
    t_options1['yAxis']['plotLines'][1]['value'] = parseFloat(filterData.UCL_MRCHART).toFixed(5) ;
    t_options1['yAxis']['plotLines'][2]['value'] = parseFloat(filterData.mr_average).toFixed(5) ;



  t_options1['yAxis']['plotLines'][0]['label']['text'] = 'LCL(' + parseFloat(filterData.LCL_MRCHART).toFixed(5) + ')';
  t_options1['yAxis']['plotLines'][1]['label']['text'] = 'UCL(' +  parseFloat(filterData.UCL_MRCHART).toFixed(5)+ ')';
  t_options1['yAxis']['plotLines'][2]['label']['text'] = 'Mean(' +  parseFloat(filterData.mr_average).toFixed(5)+ ')';


    let AvaerageValues1 = [];
    let tChart1Values1 = [];
   
    if (filterData.subgroup_diff.data) {
      AvaerageValues1 = Object.assign([], filterData.subgroup_diff.data); 
     
      if (row['CPKType'] != 'Pooled') {
        AvaerageValues1.splice(AvaerageValues1.length-1,1)
        }
      
      AvaerageValues1.map((el) => {
        if (el.abs_moving_range) {
          tChart1Values1.push(parseFloat(el.abs_moving_range));
          if (el.abs_moving_range > max) {
            max = el.abs_moving_range;
          }
        } else if (el.Val) {
          if (el.Val > max) {
            max = el.Val;
          }
          tChart1Values1.push(parseFloat(el.Val));
        } else {
          tChart1Values1.push(0);
        }
        // ////console.log(el.abs_moving_range);
      });

    } else if (isJson(filterData.subgroup_diff)) {
      AvaerageValues1 = Object.assign([], JSON.parse(filterData.subgroup_diff).data); 
     
      if (row['CPKType'] != 'Pooled') {
      AvaerageValues1.splice(AvaerageValues1.length-1,1)
      }
      
      // let tChart1Values1 = [];
      AvaerageValues1.map((el) => {
        if (el.abs_moving_range) {
          if (el.abs_moving_range > max) {
            max = el.abs_moving_range;
          }
          tChart1Values1.push(parseFloat(el.abs_moving_range));
        } else if (el.Val) {
          if (el.Val > max) {
            max = el.Val;
          }
          tChart1Values1.push(parseFloat(el.Val));
        } else {
          tChart1Values1.push(0);
        }
      });
    } else {
      AvaerageValues1 = Object.assign([], filterData.subgroup_diff); 
     
      if (row['CPKType'] != 'Pooled') {
        AvaerageValues1.splice(AvaerageValues1.length-1,1)
        }
       
      AvaerageValues1.map((el) => {
        if (el > max) {
          max = el;
        }
        tChart1Values1.push(parseFloat(el));
      });
    }
    if (max>parseFloat(filterData.UCL_MRCHART)) {
    t_options1['yAxis'].max = max;
    } else {
      t_options1['yAxis'].max = parseFloat(filterData.UCL_MRCHART);
    }   

    let ttChart1ValuesNew = [];
    tChart1Values1.map((el) => {
      if (el < parseFloat(filterData.LCL_MRCHART).toFixed(5) || el > parseFloat(filterData.UCL_MRCHART  ).toFixed(5)) {
        ttChart1ValuesNew.push({marker:{fillColor:'red'},y:parseFloat(el)});
      } else {
        ttChart1ValuesNew.push({y:parseFloat(el)});
      }
      
    });


    t_options1.series[0].data = ttChart1ValuesNew;
    return(t_options1);

  }
  
}




const GraphsData = (!validatonData) ? null : validatonData.map((el, i) => {
   
  let filterData = CapabilitySummary.features.filter(feature => feature.feature == el['FEATURE'])[0];

  let AverageValues = [];
  if (filterData.subgroup_averages) {
    AverageValues = JSON.parse(filterData.subgroup_averages).data;
  }
  let tChart1Values = [];
  if (filterData.CPKType != 'MSSD') {
      AverageValues.map((el) => {
        if (el.Val < parseFloat(filterData.LCL_ICHART).toFixed(5) || el.Val > parseFloat(filterData.UCL_ICHART).toFixed(5)) {
          tChart1Values.push({marker:{fillColor:'red'},y:parseFloat(el.Val)});
        } else {
          tChart1Values.push({y:parseFloat(el.Val)});
        }
        
      });
    } else {
      if (filterData.randomized_data) {
      filterData.randomized_data.map((el) => {
        if (el < parseFloat(filterData.LCL_ICHART).toFixed(5) || el > parseFloat(filterData.UCL_ICHART).toFixed(5)) {
          tChart1Values.push({marker:{fillColor:'red'},y:parseFloat(el)});
        } else {
          tChart1Values.push({y:parseFloat(el)});
        }
        
      });
    }
    }


   
    let max = 0;
    let AverageValues1 = [];
    let tChart1Values1 = [];
    if (filterData.subgroup_diff) {
        if (filterData.subgroup_diff.data) {
          AverageValues1 = Object.assign([], filterData.subgroup_diff.data); 
        
          if (el['CPKType'] != 'Pooled') {
            AverageValues1.splice(AverageValues1.length-1,1)
            }
          AverageValues1.map((el) => {
            if (el.abs_moving_range) {
              tChart1Values1.push(parseFloat(el.abs_moving_range));
              if (el.abs_moving_range > max) {
                max = el.abs_moving_range;
              }
            } else if (el.Val) {
              if (el.Val > max) {
                max = el.Val;
              }
              tChart1Values1.push(parseFloat(el.Val));
            } else {
              tChart1Values1.push(0);
            }
            // console.log(el.abs_moving_range);
          });
        } else if (isJson(filterData.subgroup_diff)) {
          AverageValues1 = Object.assign([], JSON.parse(filterData.subgroup_diff).data); 
        
          // let tChart1Values1 = [];
          if (el['CPKType'] != 'Pooled') {
            AverageValues1.splice(AverageValues1.length-1,1)
            }


          AverageValues1.map((el) => {
            if (el.abs_moving_range) {
              if (el.abs_moving_range > max) {
                max = el.abs_moving_range;
              }
              tChart1Values1.push(parseFloat(el.abs_moving_range));
            } else if (el.Val) {
              if (el.Val > max) {
                max = el.Val;
              }
              tChart1Values1.push(parseFloat(el.Val));
            } else {
              tChart1Values1.push(0);
            }
          });
        } else {
        
          AverageValues1 = Object.assign([], filterData.subgroup_diff); 
      
        
          if (el['CPKType'] != 'Pooled') {
            AverageValues1.splice(AverageValues1.length-1,1)
            }
          
          AverageValues1.map((el) => {
            if (el > max) {
              max = el;
            }
            tChart1Values1.push(parseFloat(el));
          });
        }
  }
    // if (max>parseFloat(filterData.UCL_MRCHART)) {
    // t_options1['yAxis'].max = max;
    // } else {
    //   t_options1['yAxis'].max = parseFloat(filterData.UCL_MRCHART);
    // }   

    let ttChart1ValuesNew = [];
    tChart1Values1.map((el,i) => {
      if (el < parseFloat(filterData.LCL_MRCHART).toFixed(5) || el > parseFloat(filterData.UCL_MRCHART  ).toFixed(5)) {
        ttChart1ValuesNew.push({marker:{fillColor:'red'},y:parseFloat(el)});
      } else {
        ttChart1ValuesNew.push({y:parseFloat(el)});
      }
      
    });

            return (

          <div class="row">

   
              {(tChart1Values.length>0)?
           
             <div id={el['FEATURE']} class='col' style={{width:'99%'}}>
                  <HighchartsReact id={el['FEATURE']} key={i}
                                    highcharts={Highcharts}
                                    options={{
                                      title: {
                                        text: (el['CPKType'] == 'Pooled')?'I Chart':'XBar Chart'
                                    },
                                    credits: {
                                      enabled: false
                                  },
                                    
                                      yAxis: {
                                        min: Math.min(parseFloat(filterData.min_val).toFixed(5),parseFloat(filterData.LCL_ICHART).toFixed(5)),
                                        max: Math.max(parseFloat(filterData.max_val).toFixed(5),parseFloat(filterData.UCL_ICHART).toFixed(5)),
                                        plotLines: [{
                                          value: parseFloat(filterData.LCL_ICHART).toFixed(5),
                                          color: 'red',
                                          dashStyle: 'shortdash',
                                          width: 2,
                                          label: {
                                              text: 'LCL(' + parseFloat(filterData.LCL_ICHART).toFixed(5) + ')'
                                          }
                                      }, {
                                          value: parseFloat(filterData.UCL_ICHART).toFixed(5),
                                          color: 'red',
                                          dashStyle: 'shortdash',
                                          width: 2,
                                          label: {
                                              text: 'UCL(' +  parseFloat(filterData.UCL_ICHART).toFixed(5)+ ')'
                                          }
                                      },{
                                        value:parseFloat(filterData.XBar).toFixed(5),
                                        color: 'green',
                                        dashStyle: 'shortdash',
                                        width: 2,
                                        label: {
                                            text: parseFloat(filterData.XBar).toFixed(5)+ ')'
                                        }
                                    },]
                                      },
                                      series: [{
                                        name:'Average Values',
                                        data: tChart1Values
                                    }]
                                  }}
                  />
            </div>: null}
            {(ttChart1ValuesNew.length>0)?
            <div   class='col' style={{width:'99%'}} >
                  <HighchartsReact id={el['FEATURE']+ "_2"} key={i + 'x'}
                          highcharts={Highcharts}
                    options={{
                      title: {
                        text:(el['CPKType'] == 'Pooled')? 'R Chart':'Moving Range Chart'
                    },
                    credits: {
                      enabled: false
                    },
                    
                    yAxis: {
                      min: 0,
                      max: (max>parseFloat(filterData.UCL_MRCHART))?max:parseFloat(filterData.UCL_MRCHART).toFixed(5),
                      plotLines: [{
                        value: parseFloat(filterData.LCL_MRCHART).toFixed(5),
                        color: 'red',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: 'LCL(' + parseFloat(filterData.LCL_MRCHART).toFixed(5) + ')'
                        }
                    }, {
                        value: parseFloat(filterData.UCL_MRCHART).toFixed(5),
                        color: 'red',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: 'UCL(' +  parseFloat(filterData.UCL_MRCHART).toFixed(5)+ ')'
                        }
                    }, {
                      value: parseFloat(filterData.mr_average).toFixed(5) ,
                      color: 'green',
                      dashStyle: 'shortdash',
                      width: 2,
                      label: {
                          text: parseFloat(filterData.mr_average).toFixed(5)+ ')'
                      }
                    }]
                    },
                      series: [{
                        name:'Range',
                        data: ttChart1ValuesNew
                    }]
                    }}
                  />
            </div> : null}
            
           </div>
            
              )
                 
 });

  const SampleExpandedComponent = ({ data }) => {
   console.log(data)
   return ( 
   <> {(Number(data.CPK) > 0 && Number(data.PPK)>0)?
      <Card className="main-card mb-3" style={{ margin: '10px' }}>
            <div class="row">
            <div class='col'>
          <div class="row">
           
            <> <div class='col' style={{maxWidth:'49%'}}>
                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={getCapabilityGraph(data,1)}
                  />
             </div>
             <div class='col' style={{maxWidth:'49%'}}>
                  <HighchartsReact
                          highcharts={Highcharts}
                    options={getCapabilityGraph(data,2)}
                  />
             </div> </>
            
             </div>
             <div class="row">
             <div class='col' id={'histogram'+ data.FEATURE} style={{maxWidth:'49%'}}>
                      
               </div>
               <div class='col' id={'qqplot'+ data.FEATURE} style={{maxWidth:'49%'}}>
                     
               </div>

             
             </div>

      </div>
      </div>
      </Card>: 

      <div class="row">
         <div class='col'> Unable to Calculate</div>
      </div>
    }
      </>

  )
  
  };
     
  return (
    <div>
    
        {(validatonData)?
         <>         <div class='card' id='outercard'>
                  <div className="card-header">
                    <div className="btn-actions-pane-right">
                      <div role="group" className="btn-group-sm btn-group">
                        <Button title="Export" style={{ float: "right", marginRight: '10px' }} onClick={() => exportPDFData()}><i  class="fas fa-file-pdf"></i></Button>
                      </div>
                    </div></div>
                    </div>
        <div>
        <div class="row">
          <div class='col' >
             <DataTable
                      title="Google Sheets-esqe"
                      columns={columns}
                      data={validatonData}
                      highlightOnHover
                      pointerOnHover
                      conditionalRowStyles={conditionalRowStyles}
                      expandableRows
                      expandOnRowClicked
                      expandableRowsComponent={<SampleExpandedComponent />}
                    />

          </div>
 
            
                                    </div>
                                    <div id='GraphsData' style={{"display":"none"}}> {GraphsData}</div> 
                                    </div>
                                    </>                       
          :null}
{
  (showCapabilityError)? <div style={{textAlign:'center'}}> Unfortunately we are Unable to generate Capability Report </div> : null}

<div id='loadingdivCapability' style={{display:'none', width: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
<div class="spinner-border m-5" role="status">
                             <span class="sr-only">Loading...</span>
                      </div>
        <div style={{ width: '100%', textAlign: "center", marginTop: '20px', fontSize: '20px' }}> Loading ..... </div>
      </div>

      <Modal isOpen={showLoader}>
        <ModalBody>
          <div style={{ width: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
            <h3> Processing </h3>
            <div class="spinner-border m-5" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </ModalBody>

      </Modal>

 
    </div>

    
  )

}


export default (withRouter(withAuth(Capability)))
